module.exports = __webpack_public_path__ + "img/nzap-nevada-report.pdf";